import GaugeChartWidget from './gauge-chart.widget';
export default GaugeChartWidget;
